import axios from "axios";
import { getHeaders, checkStatus } from "../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../Services/Global-Services/UnauthorizedTokenHandler";
const baseURL = process.env.REACT_APP_BASE_URL;

// For create a album Data.
export const postCreateAlbum = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Gallery/Album/Create`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

  export async function getAlbum(params) {
    try {
      const response = await axiosInstance.get(`${baseURL}/Gallery/Albums?AlbumId=${params.AlbumId}&EmpId=${params.EmpId}&AlbumTypeId=${params.AlbumTypeId}&Guid=${params.GUID}`, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }    
  }

// For Upload Media in album .

export const uploadImageAlbum = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Gallery/Album/Image/Add`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

    // For GET a album Media.

    export const getAlbumMediaImages = async (body) => {
      try {
        const response = await axiosInstance.post(`${baseURL}/Gallery/Album/Images`, body, {
          headers: await getHeaders(),
          body: JSON.stringify(body)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
    }

    // For GET All detail of  album Media.

    export const getAllAlbumDetailsMedia = async (body) => {
      try {
        const response = await axiosInstance.post(`${baseURL}/Gallery/Gallery`, body, {
          headers: await getHeaders(),
          body: JSON.stringify(body)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
    }

//Delete Album

export const DeleteAlbum = async (body) => { 
  try {
    const response = await axiosInstance.delete(`${baseURL}/Gallery/Album/Delete?AlbumId=${body?.AlbumId}&ModifiedById=${body?.ModifiedById}`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

//Delete Image

export const DeleteAlbumImage = async (body) => {
  try {
    const response = await axiosInstance.delete(`${baseURL}/Gallery/Album/Image/Delete?ImageId=${body?.ImageId}&AlbumId=${body?.AlbumId}`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// For Like Image in album .

export async function likeAlbumImage(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Gallery/Album/Image/Like`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  }catch(error){
    return Promise.reject(error);
  }    
}

// For Comment Image in album .

export async function albumImageComment(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Gallery/Album/Image/Comment`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  }catch(error){
    return Promise.reject(error);
  }    
}

export async function RenameAlbumName(params) {
  try {
    const response = await axiosInstance.put(`${baseURL}/Gallery/Album/Rename?AlbumId=${params.AlbumId}&Name=${params.Name}&Desc=${params.Desc}&ModifiedById=${params.ModifiedById}`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  }catch(error){
    return Promise.reject(error);
  }    
}

